export { default, meta } from "./routes/themenschwerpunkte/index.tsx";